import { jsx } from "panel";
import {
  EntryType,
  GroupEventBehaviors,
  RowLabelType,
  RowPrefixBehaviors
} from "common/query-builder/query-entry-section/types";
import { QueryEntrySectionEl } from "common/query-builder/query-entry-section";
import { BaseEntryRowEl } from "../base/template";
export function GroupedEntryRowEl({ section, entry, index }) {
  const nestedAttrs = section.helpers.getNestedSectionAttrs();
  const renderer = () => /* @__PURE__ */ jsx(QueryEntrySectionEl, {
    sel: ".contained-section",
    attrs: {
      ...nestedAttrs,
      "entry-type": EntryType.Event,
      elref: `subEntry`,
      "row-label-prefix": section.helpers.getRowLabel(index),
      "row-label-prefix-icon": section.helpers.getRowIcon(index) || ``,
      "row-label-prefix-behavior": RowPrefixBehaviors.FirstOnly,
      "row-label-type": RowLabelType.Alpha,
      "row-index": index,
      "row-index-toggleable": section.attr(`row-index-toggleable`),
      "row-index-toggle-icon": section.attr(`row-index-toggle-icon`),
      "row-draggable": false,
      "group-event-behavior": GroupEventBehaviors.Append,
      "track-properties": { ...nestedAttrs[`track-properties`] || {}, sectionName: `grouped-entry` },
      entries: entry.event
    },
    on: {
      update: (ev) => section.helpers.onGroupedSectionUpdate(index, ev),
      entryIndexLabelClicked: () => section.helpers.onEntryIndexLabelClicked(index)
    }
  });
  return /* @__PURE__ */ jsx(BaseEntryRowEl, {
    index,
    el: section,
    entry,
    hideActions: true,
    isPlaceholder: false,
    showLabels: false,
    rowRenderer: { selectorRenderer: renderer }
  });
}
